import React from 'react'
import ChangePassword from './ChangePassword'
import { getUserFromToken } from '../Utils';
export default function Profile() {
    const user = getUserFromToken();

    return (
        <>
            <div className='page-title-container'>

                <h2>My Profile <span>Mange my profile from here.</span></h2>
            </div>
            <div className='row g-4'>
                <div className='col-md-3'>

                    <div className="card  my-4" >
                        <img className="card-img-top" src="/assets/image/avatar5.png" alt="Card image cap" />
                        <div className="card-body">
                            <h5 className="card-title">{user?.full_name}</h5>
                            <p className="card-text">
                                <i className="bi bi-envelope me-2"></i>{user?.email}
                            </p>
                            <p className="card-text">
                                <i className="bi bi-telephone me-2"></i>{user?.phone}
                            </p>
                            <p className="card-text">
                                <i className="bi bi-calendar me-2"></i>
                                {user?.dob}
                            </p>
                        </div>
                    </div>
                </div>
                <div className='col-md-9'>

                    <div className="card my-4" >
                        <div className="card-body">
                            <div className='page-title-container'>
                                <h5 className="card-title">Change Password</h5>
                            </div>
                            <ChangePassword />
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
